<template>
  <div>
    <!-- Bouton de rafraîchissement -->
    <b-row class="justify-content-start">
      <b-col cols="4" lg="2" xl="1" class="mb-5">
        <b-button
          class="btnFilter"
          :disabled="activateSpinner"
          @click="onRefresh()">
          <i class="fa-light fa-rotate-right fs-14px"></i>
        {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="justify-content-start align-items-center" :class="{'filter-item-section':true}">
      <!-- Filtre IBAN -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-iban">{{ $t('common.entity_account.iban_encrypted') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="IbanEncrypted"
            id="filter-iban"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': IbanEncrypted}"
            :placeholder="$t('common.entity_account.iban_encrypted')"
            style="width: 100%">
        </span>
      </b-col>
      <!-- Filtre Référence IBAN -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-iban-reference">{{ $t('common.entity_account.iban_reference') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="IbanReference"
            id="filter-iban-reference"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': IbanReference}"
            :placeholder="$t('common.entity_account.iban_reference')"
            style="width: 100%">
        </span>
      </b-col>
    </b-row>

    <b-row class="justify-content-end">
      <!-- Boutons Effacer et Appliquer -->
      <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
        <b-button class="mr-3" size="sm"
                  @click="clearFilterFields" :disabled="activateSpinner">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
      <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
        <b-button class="btn" size="sm"
                  @click="onRefresh">
          {{ $t('common.srch') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col cols="12">
        <div style="overflow:auto">
          <spinner v-if="activateSpinner"></spinner>
          <b-table v-else-if="!isMandatoryFieldMiss && listItemsEntityAccount.length > 0"
            :items="listItemsEntityAccount"
            :fields="fields"
            class="table-striped"
            hover
            :empty-text="$t('common.security.no_result')"
            style="margin-bottom:0"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDir"
            @head-clicked="sortTable"
            :key="refreshKey">
            <template #cell(StatusImportIban)="data">
              <span>{{ $t('common.entity_account.iban_import_status_' + data.value) }}</span>
            </template>
            <template #cell(FileReference)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(DateAction)="data">
              <span>{{ getDate(data.value) }}</span>
            </template>
          </b-table>
          <div v-else class="d-flex justify-content-center">
            <span class="noResult">
              {{ isMandatoryFieldMiss ? $t('common.missing_a_required_field') : $t('common.no_result') }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "EntityAccountList",
  components: {
    'cm-pagination': Pagination,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      filterConditions: {},
      listItemsEntityAccount: [],
      listTitle: "",
      IbanEncrypted: '',
      IbanReference: '',
      isMandatoryFieldMiss: true,
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.listTitle = this.$i18n.t("common.entity_account.iban_history")
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getEntityAccount(index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    // this.getEntityAccount()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'DateAction',
        label: this.$t('common.entity_account.date_action'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'StatusImportIban',
        label: this.$t('common.entity_account.iban_import_status'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'FileReference',
        label: this.$t('common.entity_account.file_reference'),
        class: 'text-center',
        sortable: true
      })
      return fields
    }
  },
  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getEntityAccount()
    },
    clearFilterFields() {
      this.isMandatoryFieldMiss = true
      this.paginationObject = {}
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.IbanEncrypted = ''
      this.IbanReference = ''
      // this.applyFilter()
    },
    getEntityAccount(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        IbanEncrypted: this.IbanEncrypted,
        IbanReference: this.IbanReference,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.entityAccount.getEntityAccount(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.EntityAccount.length

        let EntityAccountList = {}

        EntityAccountList = resp.data.EntityAccount

        that.updateEntityAccount(EntityAccountList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getDate (date) {
      if (date != ''){
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss.SSS')
      }
      else {
        return '-'
      }
    },
    onRefresh() {
      if (!this.IbanEncrypted && !this.IbanReference) {
        this.isMandatoryFieldMiss = true
        return
      }
      this.isMandatoryFieldMiss = false
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getEntityAccount()
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'StatusImportIban',
        'FileReference',
        'DateAction'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateEntityAccount(EntityAccountList) {
      this.listItemsEntityAccount = EntityAccountList
    }
  }
}
</script>
